<template>
    <div>
        <PassengerTripCard :trip="trip" v-if="trip" class="float-container--top"></PassengerTripCard>
        <div v-if="!cancelling" class="float-container--bottom">
            <div :class="!this.settings.modulo_flujo_tipo_uber ? 'btn-action-container' : 'float-container--bottom'">
                <button class="btn btn-primary btn-lg btn-heavy " v-lang.subir @click="onRideUp" :disabled="buttonFlag" v-if="!this.settings.modulo_flujo_tipo_uber && canAdvanceReservation">Subir</button>
                <button class="btn btn-secondary btn-heavy" :class="!this.settings.modulo_flujo_tipo_uber ? '' : 'btn-lg'" v-lang.cancelar @click="openCancelDialog">Cancelar</button>
            </div>
        </div>
        <cancel-card @close_card="onCloseCard" @cancel_trip="onCancelTrip" v-if="cancelling && cancelReasonModuleEnabled"></cancel-card>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PassengerTripCard from './PassengerTripCard.vue';
import dialogs from '@/services/dialogs';
import { reservationAdvanceAllowed } from '@/services/reservation';

export default {
    name: 'passengerTripArrived',
    props: [
    ],
    data () {
        return {
            buttonFlag: false,
            cancelling: false
        };
    },
    computed: {
        ...mapGetters({
            logged: 'auth/checkLogin',
            user: 'auth/user',
            isMobile: 'device/isMobile',
            trip: 'passenger/actualTrip',
            settings: 'company/config',
            position: 'geolocation/actual',
            cancelReasonModuleEnabled: 'company/cancelReasonModuleEnabled'
        }),
        canAdvanceReservation () {
            return reservationAdvanceAllowed(this.trip, this.settings);
        }
    },
    mounted () {
        this.language = this.$getLang();
    },

    methods: {
        ...mapActions({
            cancelTrip: 'passenger/cancelTrip',
            rideupTrip: 'passenger/rideupTrip'
        }),
        openCancelDialog () {
            if (this.cancelReasonModuleEnabled) {
                this.cancelling = true;
            } else {
                dialogs.confirm(this.translate('confirmarCancelacion'), (index) => {
                    if (index === 1) {
                        this.onCancelTrip('CANCELANDO CONFIRMANDO');
                    }
                }, this.translate('cancelarServicio'), [this.translate('si'), this.translate('no')]);
            }
        },
        onCloseCard () {
            this.cancelling = false;
        },
        onCancelTrip (reasonText, reasonOption) {
            this.buttonFlag = true;
            let data = {
                lat: this.position ? this.position.lat : 0,
                lng: this.position ? this.position.lng : 0,
                comentario: reasonText
            };
            if (reasonOption) {
                data.razon_cancelacion = reasonOption;
            }
            this.cancelTrip(data);
        },
        onRideUp () {
            this.buttonFlag = true;
            let data = {
                lat: this.position ? this.position.lat : 0,
                lng: this.position ? this.position.lng : 0
            };
            this.rideupTrip(data);
        }

    },
    components: {
        PassengerTripCard
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/passenger/TripArrived.vue